import { render, staticRenderFns } from "./ModalDesconto.vue?vue&type=template&id=d9cada54"
import script from "./ModalDesconto.vue?vue&type=script&lang=js"
export * from "./ModalDesconto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports